const Header = () => {
    return (
        <section>
            <div className="text-center">
                <img alt='DETSYS' src="/static/frontlogo.png" />
                <h1>DETSYS</h1>
            </div>
        </section>
    );
};

export default Header;